<template>
  <div class="callMatch">
    <!-- <div class="head">
      <nav-back
        class="back_btn"
        title="老带新推荐"
        :titleColor="'#333'"
        :backUrl="require('../../common/images/progress/back_hei.png')"
      />
    </div> -->
    <div class="main">
      <div class="recommendUser">
        <div class="label">推荐人</div>
        <div class="user_info">
          <div class="name">{{ date.rec_username }}</div>
          <div class="mobile">{{ date.rec_user_phone }}</div>
        </div>
      </div>
      <div class="content">
        <div class="post_card">
          <div class="user">
            <div class="user_wrap">
              <div class="name">
                <span>姓名</span>
                <span class="user_label">
                  {{ date.surname + date.user_name }}
                </span>
              </div>
              <div class="gender">
                <span>性别</span>
                <span class="user_label">
                  {{ date.gender == 0 ? "男" : "女" }}
                </span>
              </div>
              <div class="tel">
                <span>电话</span>
                <span class="user_label">{{ date.contact_number }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_area">
        <div class="match" @click="match(1)">匹配</div>
        <div class="unmatch" @click="match(0)">不匹配</div>
      </div>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
import navBack from "@/components/navBack";
import { Toast } from "vant";
export default {
  components: {
    "nav-back": navBack,
    loading,
  },
  data() {
    return {
      loadingStatus: false,
      date: {},
    };
  },
  created() {
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');
    document.title = "老带新推荐";
    // this.$jsBridge.callHandler('toggleTitleBar', '{"showTitleBar":false}');

    this.date = this.$route.query;
  },
  mounted() {
    if (this.$route.params.isFirst) {
      setTimeout(() => {
        window.location.href = "tel:" + this.date.mobile;
      }, 500);
    }
  },
  methods: {
    match(e) {
      this.loadingStatus = true;
      this.$api
        .getIfMatch({ recommendId: this.date.id, ifMatch: e })
        .then((res) => {
          if (res.code === "0000") {
            this.loadingStatus = false;
            if (e === 0) {
              // 未匹配

              Toast.fail("匹配失败");
              setTimeout(() => {
                this.$router.go(-2);
              }, 2000);
            } else if (e === 1) {
              this.$router.push({
                name: "userInfo",
                params: {
                  id: this.date.id,
                  type: 3,
                  name: this.date.user_name,
                  tel: this.date.contact_number,
                  allname: this.date.allname,
                },
              });
            }
          }
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.callMatch {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .head {
    height: 100px;
    overflow: hidden;
    border-bottom: 0.01rem solid #dddddd;
    .back_btn {
      display: inline-block;
      width: 100px;

      font-weight: 500;
    }
    .back {
      display: inline-flex;
      height: 50px;
      margin-top: 20px;
      width: 100%;
    }
  }
  .main {
    padding: {
      left: 38px;
      right: 38px;
    }
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .recommendUser {
      display: flex;
      height: 124px;
      font-size: 28px;
      color: #333333;
      line-height: 124px;
      padding: {
        left: 32px;
        right: 32px;
      }
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      .label {
        width: 200px;
        height: 100%;
        color: #666666;
      }
      .user_info {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .mobile {
          margin-left: 70px;
        }
      }
    }
    .content {
      flex: 4;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .post_card {
        width: 674px;
        height: 780px;
        background-image: url("../../common/images/progress/match_bg.png");
        background-size: 100% 100%;
        display: flex;
        align-items: flex-end;
        .user {
          width: 100%;
          height: 366px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .gender {
            margin: {
              top: 26px;
              bottom: 26px;
            }
          }
          .user_label {
            margin-left: 80px;
          }
        }
      }
    }
    .btn_area {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      color: #fff;
      font-weight: 500;
      div {
        width: 260px;
        height: 100px;
        background-size: 100% 100%;
        line-height: 100px;
        text-align: center;
      }
      .match {
        background-image: url("../../common/images/progress/match.png");
      }
      .unmatch {
        background-image: url("../../common/images/progress/unmatch.png");
      }
    }
  }
}
</style>
